import React, { useState } from "react";
import "./style.scss";

export const CookiePopup = () => {
  const [isVisible, setIsVisible] = useState(
    !localStorage.getItem("cookiesAccepted")
  );

  const handleAccept = () => {
    setIsVisible(false);
    localStorage.setItem("cookiesAccepted", "true");
  };

  if (!isVisible) return null;

  return (
    <div className="wrapper-cookie-popup">
      <div className="container cookie-popup">
        <p>
          На сайте используются файлы cookie и иные технологии для сбора
          обезличенной информации о действиях пользователей. Это помогает нам
          улучшать работу сайта и качество услуг. Нажимая «Понятно», вы даёте
          согласие на обработку персональных данных в соответствии с{" "}
          <a href="/privacy-policy/ru" className="cookie-link" target="blank">
            Политикой обработки персональных данных
          </a>
          . Запретить обработку cookie вы можете через браузер.
        </p>
        <button className="btn-action" onClick={handleAccept}>
          Понятно
        </button>
      </div>
    </div>
  );
};
